import { render } from "./ManufacturingGrant.vue?vue&type=template&id=5f81cf69"
import script from "./ManufacturingGrant.vue?vue&type=script&lang=js"
export * from "./ManufacturingGrant.vue?vue&type=script&lang=js"

import "./ManufacturingGrant.vue?vue&type=style&index=0&id=5f81cf69&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__